// export const urlPath = '/aiwrite';
export const urlPath = '/api/aiwrite';

// export const proxyUrlPath = '/aiwrite';
export const proxyUrlPath = '/api/aiwrite';
